import AppointmentContainer from "./TwoFANotEnabledOTPVarified.container";

export default AppointmentContainer;
